// @noflow
import React from 'react'

import {
  Direction,
  ICON_COLOURS,
  IconColours
} from '@/components/elements/atoms/Icon/Icon'

import STYLES from './paw.module.sass'

type Props = {
  size: number
  accentColour: IconColours
  width?: number | string
  direction?: Direction
}

const Paw = ({
  size,
  accentColour,
  width,
  direction = 'right'
}: Props): JSX.Element => {
  return (
    <svg
      height={size}
      width={width || '100%'}
      viewBox="0 0 26 27"
      className={`${direction ? STYLES[direction] : ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.56 11.5c.061-.198.117-.397.183-.593.154-.46.29-.929.476-1.375.237-.564.672-.975 1.129-1.365.517-.442 1.105-.75 1.739-.98a.264.264 0 01.06-.015c.976-.114 1.95-.242 2.93-.335.835-.08 1.672-.028 2.506.071a20.03 20.03 0 012.414.43 6.282 6.282 0 013.32 2.046c.635.733 1.134 1.557 1.57 2.419.659 1.297 1.192 2.643 1.547 4.055.327 1.298.27 2.59-.054 3.88-.274 1.096-.791 2.067-1.44 2.978-.375.525-.74 1.058-1.184 1.528-.68.719-1.492 1.251-2.377 1.675-.413.197-.836.377-1.261.549-.918.373-1.875.428-2.85.32l-.438-.046-.62-.127-.054-.03c-.248-.112-.506-.208-.744-.342-.482-.273-.887-.653-1.312-1.006a3.795 3.795 0 01-1.154-1.668c-.432-1.197-.617-2.43-.487-3.699.026-.26.092-.518.155-.773.032-.132.1-.254.145-.384.07-.208.03-.322-.157-.438a3.195 3.195 0 00-.297-.16c-.661-.319-1.316-.65-1.902-1.101-1.37-1.058-2.023-2.466-2.02-4.188 0-.193.02-.386.03-.578l.148-.747zM17.308.308c.105.049.214.09.313.147.223.132.316.36.394.593.1.298.138.606.134.916a2.13 2.13 0 01-.167.771 8.711 8.711 0 01-.804 1.505c-.246.375-.519.732-.78 1.096-.158.218-.312.44-.477.651-.23.295-.546.455-.89.561-.237.073-.464.176-.719.177a.523.523 0 01-.465-.344 2.504 2.504 0 01-.142-.814c0-.215.035-.428.124-.622.266-.583.538-1.161.804-1.744.26-.57.54-1.128.865-1.661.193-.317.464-.553.754-.767.173-.127.346-.251.522-.373.048-.033.106-.053.159-.08l.375-.012zm7.15 21.208c-.1.227-.22.446-.419.609-.11.09-.237.179-.37.218-.434.13-.876.22-1.33.217a2.285 2.285 0 01-.79-.168c-.56-.21-1.123-.41-1.68-.625a2.647 2.647 0 01-.457-.236.612.612 0 01-.306-.616 3.59 3.59 0 01.131-.665c.107-.339.356-.573.686-.729.403-.19.833-.237 1.267-.25 1.12-.036 2.122.282 3.04.847a.46.46 0 01.212.313c.043.222.061.449.089.674.003.026.002.052.003.078l-.075.333zm-3.115-4.727c-.483-.124-.905-.345-1.22-.772-.462-.623-.455-1.479.021-2.044a.871.871 0 01.583-.322c.726-.078 1.453-.133 2.189-.064a5.055 5.055 0 011.656.42c.347.16.55.434.61.825.068.448.045.874-.212 1.244a.893.893 0 01-.462.368c-.765.236-1.542.428-2.356.415-.27-.005-.54-.046-.809-.07zm.65-8.758c-.242 1.052-.81 1.937-1.71 2.644-.59.464-1.236.545-1.917.327-1.354-.552-.99-1.53-.852-1.702.215-.265.436-.529.677-.774.748-.76 1.636-1.333 2.638-1.748.232-.096.458-.205.715-.216.308-.013.501.12.565.395.056.243.005.487-.033.73-.018.116-.055.23-.082.344z"
        fill={ICON_COLOURS[accentColour]}
        fillRule="evenodd"
      />
    </svg>
  )
}

export default Paw
